import React from 'react';
import { QuoteIcon, UserIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { patientScenarios } from '../../data/content';
export function Problem() {
  return <Section tone="cream" data-id="element-231" data-mp="2rmu4ub4ltttj">
      <SectionTitle data-id="element-232" data-mp="2rm2990b0bw39">
        Stop Guessing.
        <br data-id="element-233" data-mp="2mo93279pf22z" />
        <span className="text-gold-dark" data-id="element-234" data-mp="2moiv00eb7jbb">
          Start Practicing with Clinical Confidence.
        </span>
      </SectionTitle>

      <p className="mt-5 text-center text-[15px] leading-relaxed text-navy/70 sm:text-lg" data-id="element-235" data-mp="2ho4ncjgmebdt">
        Every week, physicians face patients whose menopausal symptoms don't fit
        neatly into a textbook.
      </p>

      <ul className="mt-6 space-y-3" data-id="element-236" data-mp="23qg0j62zsu64">
        {patientScenarios.map(scenario => <li key={scenario} className="flex items-start gap-3 rounded-2xl border border-navy/10 bg-white p-4" data-id="element-237" data-mp="23sspw4b2y6t7">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-navy/5" data-id="element-238" data-mp="204kboayr7a9">
              <UserIcon className="h-4 w-4 text-navy" data-id="element-239" data-mp="14a0mc07htd0j" />
            </span>
            <p className="pt-1 text-[14.5px] font-medium leading-snug text-navy/85" data-id="element-240" data-mp="19aoe4o3jpxvt">
              {scenario}
            </p>
          </li>)}
      </ul>

      <div className="mt-8 rounded-3xl bg-navy p-6 text-center text-white" data-id="element-241" data-mp="vcgn0wt6xqsk">
        <QuoteIcon className="mx-auto h-6 w-6 text-gold" data-id="element-242" data-mp="10a0a8m7v9dwn" />
        <p className="mt-3 text-[15px] leading-relaxed text-white/85" data-id="element-243" data-mp="1nyj7m6pdo69y">
          The science exists. The evidence is available. But applying that
          evidence in a busy clinic isn't always easy.
        </p>
        <p className="mt-4 font-display text-xl font-bold leading-snug sm:text-2xl" data-id="element-244" data-mp="1ea1aq0k7yjbl">
          That's exactly why the Menopause Clinical Blueprint™ was created.
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-white/85" data-id="element-245" data-mp="26y6x0rqx8gdj">
          Instead of reading hundreds of pages from multiple organizations, you
          simply follow{' '}
          <strong className="text-gold" data-id="element-246" data-mp="2bqgjfxstuyb2">one clear clinical pathway.</strong>
        </p>
      </div>

      <CTAButton className="mt-8" variant="navy" label="I want one clear clinical pathway" subline="Instant access • $27 one-time payment" data-id="element-247" data-mp="2li9oksudec16" />
    </Section>;
}